module.exports = __webpack_public_path__ + "static/media/ServiceOrderTemplate1.f08a22be.png";